<div
  class="tw-flex tw-flex-col"
  [ngClass]="{
  'tw-space-y-2': labelSlot || label !== '',
}"
>
  @if (labelSlot) {
  <ng-container *ngTemplateOutlet="labelSlot" />
  } @else {
  <label class="tw-text-sm tw-font-medium tw-text-gray-700" [for]="id">
    {{ label }}
  </label>
  }
  <ng-select
    class="reactive-ng-select"
    [dropdownPosition]="dropdownPosition"
    [appendTo]="appendTo"
    [items]="options"
    [inputAttrs]="{
      id: id,
    }"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [ariaPlaceholder]="placeholder"
    [placeholder]="placeholder"
    [clearable]="clearable"
    [formControl]="formControl"
    [appearance]="appearance"
    [loading]="loading"
    [loadingText]="loadingText"
    [id]="id"
    [searchFn]="searchFn"
    [trackByFn]="trackByFn"
    (search)="onSearch($event)"
    (blur)="onBlur($event)"
    (focus)="onFocus($event)"
    (open)="onOpen($event)"
    (close)="onClose($event)"
    (clear)="onClear($event)"
    (remove)="onRemove($event)"
    (add)="onAdd($event)"
  >
    <!--
      This should be populated with the ng-option-tmp directive if you want to
      use the ng-select component.

      Example:
        <ng-template
        ng-option-tmp
        let-item="item"
        let-index="index"
        class="tw-border-red-500"
      >
        <div>{{ item.name }}</div>
      </ng-template>
      -->
    @if (optionsSlot) {
    <ng-container *ngTemplateOutlet="optionsSlot"></ng-container>
    }
  </ng-select>
  @if (formControl.touched && formControl.errors) {
  <span class="tw-text-sm tw-text-red-500 tw-font-medium tw-mt-1">
    {{ "error" }}
  </span>
  }
</div>
